import React, { Component } from "react";
import {
  company,
  profile,
  GET,
  POST,
  alert,
  loading,
  t
} from "./CustomComponent.js";
import Language from "../components/Language.js";
import CustomerPickerModal from "./customer/CustomerPickerModal.js";
import {
  isStaffViewingCustomerPortal,
  getSelectedCustomer,
  clearSelectedCustomer,
} from "../utils/customerScope";
import { Navbar, Nav } from "react-bootstrap";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import { clearStorageKeepLang } from "../utils/backendMessage";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_balance_available: 0,
      total_balance_thb: 0,
      total_balance_lak: 0,
      dropdown: "",
      array_link: [...this.filterMenu(profile)],
      user_profile: profile,
      modal_news: false,
      announce_datetime: "",
      announce_duration: 0,
      announce_detail: "",

      // พนักงานภายในต้องเลือกลูกค้าก่อนถึงจะเห็นข้อมูลในพอร์ทัลนี้ (ลูกค้าเองผูกกับรายตัวเองจาก token)
      selected_customer: getSelectedCustomer(),
      modal_customer: false,
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  sidebar_ref = React.createRef();
  sidebar_scroll_key = "sidebar_scroll_customer";

   componentDidMount = async () => {
      // โหลดโปรไฟล์
      await this.GetProfile();
  
      // ตรวจสอบการล็อกอิน
      if (!profile) {
        window.location.href = "/";
        return;
      }

      // คืนตำแหน่ง scroll ของเมนูด้านซ้าย ให้เห็นเมนูที่เลือกอยู่
      this.restoreSidebarScroll();
    };

  /**
   * พนักงานภายในที่ยังไม่ได้เลือกลูกค้า -> เด้ง modal ให้เลือกก่อน (ปิดเองไม่ได้)
   * ทุกหน้าใน /cs/* เรนเดอร์ navbar ตัวนี้ จึงคุมได้จากที่เดียว
   */
  syncCustomerScope = () => {
    const currentProfile = this.state.user_profile || profile;
    if (!isStaffViewingCustomerPortal(currentProfile)) return;

    const selected = getSelectedCustomer();
    this.setState({ selected_customer: selected, modal_customer: !selected });
  };

  openCustomerPicker = () => this.setState({ modal_customer: true });

  closeCustomerPicker = () => this.setState({ modal_customer: false });

  changeCustomer = () => {
    clearSelectedCustomer();
    this.setState({ selected_customer: null, modal_customer: true });
  };
  GetProfile = async () => {
    // session พอร์ทัลลูกค้า (เข้าด้วยเลขผู้เสียภาษี) ไม่มีบัญชีผู้ใช้ - /admin/users/profile ใช้ไม่ได้ ใช้โปรไฟล์ที่เก็บไว้ตอนเข้า
    if (profile?.portal_limited) {
      this.permissionSetting();
      return;
    }
    const result = await GET("admin/users/profile", null, false);
    if (result?.status) {
      localStorage.setItem("cm-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [...this.filterMenu(result.data)],
      });
      this.permissionSetting();
      this.syncCustomerScope();
    }
  };
  async componentDidUpdate() {
    this.permissionSetting();
    this.restoreSidebarScroll();
  }

  handleSidebarScroll = (e) => {
    sessionStorage.setItem(this.sidebar_scroll_key, e.target.scrollTop);
  };

  restoreSidebarScroll = () => {
    if (this.sidebar_restored || this.sidebar_restoring) return;
    const el = this.sidebar_ref.current;
    // ยังไม่ render หรือถูกซ่อนอยู่ (จอเล็ก) ให้ข้ามไปก่อน
    if (!el || !el.clientHeight) return;
    this.sidebar_restoring = true;

    requestAnimationFrame(() => {
      this.sidebar_restoring = false;
      // เมนูยังสั้นกว่าจอ (ยัง render ไม่ครบ) ไม่ต้องเลื่อน รอรอบถัดไป
      if (el.scrollHeight <= el.clientHeight) return;
      this.sidebar_restored = true;

      const saved = Number(sessionStorage.getItem(this.sidebar_scroll_key));
      if (saved > 0) {
        el.scrollTop = saved;
        return;
      }
      // ไม่มีค่าที่จำไว้ ให้เลื่อนเมนูที่ active มากลางจอ
      const active = el.querySelector(".nav-link-sidebar.active");
      if (!active) return;
      const top =
        active.getBoundingClientRect().top -
        el.getBoundingClientRect().top +
        el.scrollTop;
      el.scrollTop = Math.max(0, top - el.clientHeight / 2 + active.offsetHeight / 2);
    });
  };
  filterMenu = (profile) => {
    let perms = profile?.role?.permission || [];

    const menu = global.menu_customer?.filter(
      (item) =>
        !item.link ||
        perms.includes(item.permission),
    );
    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };
  permissionSetting = () => {
    const role = new Set(this.state.user_profile?.role?.permission || []);
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
  };
  componentMenu = () => {
    const classNameBTN =
      "nav-link-sidebar d-flex align-items-center py-2 px-3 mb-1 rounded-lg text-decoration-none";
    const classNameICON = "icon wpx-24 text-center me-3";
    // path ปัจจุบัน (ตัด / ท้าย และ query ออก) ใช้เทียบว่าตอนนี้อยู่เมนูไหน
    const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
    const currentType = new URLSearchParams(window.location.search).get("type");
    // เลือก link ที่ match ยาวที่สุด เพื่อให้หน้าย่อย (เช่น /cs/work-requests/create)
    // ยัง highlight เมนูแม่อยู่ และไม่ชนกับเมนูที่ชื่อขึ้นต้นเหมือนกัน (/wh/stock vs /wh/stock-claim)
    const activeLink = this.state.array_link
      .filter((menu) => menu.link)
      .map((menu) => menu.link.replace(/\/+$/, ""))
      .filter((link) => currentPath === link || currentPath.startsWith(`${link}/`))
      .sort((a, b) => b.length - a.length)[0];
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        href={href}
        key={href}
        aria-current={isActive ? "page" : undefined}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
      >
        <span className={classNameICON}>
          {icon}
        </span>
        <span className="flex-grow-1">{t(label)}</span>
        {extra}
      </a>
    );

    const { array_link, user_profile } = this.state;

    return (
      <div className="sidebar-menu">
        {user_profile?.portal_limited && (
          <div className="rounded-3 px-3 py-2 mb-2 mx-1" style={{ backgroundColor: "#FFF3CD", color: "#664d03" }} role="status">
            <div className="text-13 fw-bold">{t("customer_portal_limited_badge")}</div>
            <div className="text-12">{t("customer_portal_limited_badge_desc")}</div>
          </div>
        )}
        {array_link.map((item, i) => {
          if (item.title)
            return (
              <div className="sidebar-section-title text-uppercase text-secondary small fw-semibold px-3 py-2 mt-1 mb-1" key={`title-${i}`}>
                {t(item.title)}
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${
            item.type || item.country ? "?" + params : ""
          }`;
          // เมนูที่ active = link ตรงกับ path ปัจจุบัน และถ้าเมนูมี type ต้องตรงกับ ?type= ด้วย
          const isActive =
            item.link.replace(/\/+$/, "") === activeLink &&
            (item.type == null || String(item.type) === currentType);
          return linkItem(
            `${href}`,
            item.icon,
            item.name,
            isActive,
            item.component,
          );
        })}

        {/* <hr className="my-3 mx-3 sidebar-divider" /> */}

        <div className="d-block d-xl-none px-2">
          <button
            className={`${classNameBTN} w-100 text-danger border-0 bg-transparent`}
            onClick={async () => {
              this.Logout();
            }}
          >
            <span className={classNameICON}>
              {"\uf2f5"}
            </span>
            <span>{["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}</span>
          </button>
        </div>
        <div className="d-none d-xl-block hpx-100"></div>
      </div>
    );
  };
  Logout = async () => {
      const {user_profile} = this.state;
      if (user_profile?.portal_limited) {
        // ไม่มี token ฝั่ง server ให้ revoke (auth/logout ใช้กับ session นี้ไม่ได้) แค่ล้างฝั่งเครื่องแล้วกลับหน้ากรอกเลข
        if (await alert("", "warning", t("confirm"), t("logout_ask"), t("logout"), t("cancel"))) {
          clearStorageKeepLang();
          window.location.href = "/customer-portal";
        }
        return;
      }
      if(["super_user","admin-company"].includes(user_profile?.user_type)){
  window.location.href = "/portal";
      }else{
    // โมดูลที่เข้าได้จริง (ผ่านทั้งล็อกตาม user_type และ permission ของ role)
    // มีมากกว่า 1 โมดูลจึงพากลับไปหน้าเลือกพอร์ทัล - ช่างมีแค่พอร์ทัลแอดมิน จึง logout ตรง ๆ
    const module = global.getAccessibleModules(user_profile);
    if(module.length >1){
      window.location.href = "/portal";
    }
  if (
         await alert(
                "",
                "warning",
                t("confirm"),
                t("logout_ask"),
                t("logout"),
                t("cancel"),
              )
      ) {
        loading(true);
        let result = await POST("auth/logout");
        if (result?.status) {
          clearStorageKeepLang();
          window.location.href = "/";
        }
        loading(false);
      }
      }
    };

  render() {
    const {
      user_profile,
      selected_customer,
      modal_customer,
    } = this.state;
    const isStaff = isStaffViewingCustomerPortal(user_profile);
    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-white position-fixed w-100"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid var(--bs-gray-2)" }}
          expand="xl"
        >
          <Navbar.Brand href={global.getFirstAccessibleLink(global.menu_customer, user_profile?.role?.permission) || "/cs/dashboard"} className="fw-bold text-dark d-flex">
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer d-none d-sm-block"
                onClick={() => {
                  window.location.href = global.getFirstAccessibleLink(global.menu_customer, user_profile?.role?.permission) || "/cs/dashboard";
                }}
              />
              <img
                alt="logo"
                src={LOGO}
                height={30}
                style={{ objectFit: "contain" }}
                className="pointer d-block d-sm-none"
                onClick={() => {
                  window.location.href = global.getFirstAccessibleLink(global.menu_customer, user_profile?.role?.permission) || "/cs/dashboard";
                }}
              />
              <span className="position-absolute d-none d-sm-block" style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}>
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </Navbar.Brand>
          <div className="d-flex">
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav"/>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                {isStaff && (
                  <>
                    <div className="d-flex align-items-center px-3 py-1 rounded-pill me-3" style={{ backgroundColor: "#EAF2FF" }}>
                      <span className="icon text-primary me-2">{"\uf1ad"}</span>
                      <div className="pe-2">
                        <div className="text-10 text-secondary" style={{ marginBottom: -2 }}>{t("viewing_as_customer")}</div>
                        <div className="text-13 fw-bold text-dark">{selected_customer?.name || t("no_customer_selected")}</div>
                      </div>
                      <button
                        className="btn btn-sm border-0 p-1 text-primary fw-bold text-12"
                        onClick={this.changeCustomer}
                        title={t("change_customer")}
                      >
                        <span className="icon">{"\uf021"}</span>
                      </button>
                    </div>
                  </>
                )}
                 <Language/>
                <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: 'var(--bs-gray-2)' }}/>
                <div className="d-none d-xl-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                  <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: '0.75rem' }}>
                    {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="pe-2">
                    <div className="text-14 fw-semibold text-dark">
                      {user_profile?.full_name || "Username"}
                    </div>
                    <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                      {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-xl-none mb-5 pt-4 overflow-scroll" style={{ height: "80vh" }}>
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 sidebar-dark overflow-scroll d-none d-xl-block"
          ref={this.sidebar_ref}
          onScroll={this.handleSidebarScroll}
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
          }}
        >
          <div
            className="d-flex pt-3 position-fixed sidebar-dark pb-3 px-3 wpx-260 sidebar-brand"
            style={{
              border: "0",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <span className="text-20 icon text-white">{"\uf494"}</span>
              <span className="text-20 text-white fw-bold" title={company?.name || ""}>{company?.name || "-"}</span>
              {/* version */}
              <div className="mt-2">
                <small className="position-absolute text-11 text-secondary" style={{ top: 38, left: 47 }}>version {global.version}</small>
              </div>
            </div>
          </div>
          <div className="px-3" style={{ marginTop: 60, paddingBottom: 80 }}>
            {isStaff && (
              <div className="rounded-3 p-2 mb-3" style={{ backgroundColor: "#334155" }}>
                <div className="text-10 text-uppercase" style={{ color: "#94a3b8" }}>{t("viewing_as_customer")}</div>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <div className="text-13 fw-bold text-white text-truncate">
                      {selected_customer?.name || t("no_customer_selected")}
                    </div>
                  </div>
                  <button
                    className="btn btn-sm border-0 p-1 text-white"
                    style={{ opacity: 0.8 }}
                    onClick={this.changeCustomer}
                    title={t("change_customer")}
                  >
                    <span className="icon">{"\uf021"}</span>
                  </button>
                </div>
              </div>
            )}
            {this.componentMenu()}
          </div>
          <div
            className="position-fixed sidebar-dark pb-3 px-3 wpx-260"
            style={{
              bottom: 0,
              zIndex: 3,
              border: "0",
              borderTop: "1px solid #334155",
              paddingTop: "12px",
            }}
          >
            <div className="d-flex align-items-center text-start w-100 p-2 rounded-lg" style={{ backgroundColor: '#334155' }}>
              <span className="user-avatar me-2 wpx-36 hpx-35 d-flex align-items-center justify-content-center" style={{ fontSize: '0.8rem' }}>
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="flex-grow-1 overflow-hidden">
                <div className="text-14 fw-semibold text-white text-truncate">
                  {user_profile?.full_name || "Username"}
                </div>
                {/* ISS-005: เดิม #94a3b8 บนพื้น #334155 ได้ contrast 4.04:1 (ไม่ผ่าน AA ที่ขนาด 12px)
                    ใช้ slate-300 ชุดเดียวกับเมนูข้าง ได้ 6.97:1 */}
                <div className="text-12 text-truncate" style={{ marginTop: -2, color: '#cbd5e1' }}>
                  {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                </div>
              </div>
              <button
                className="btn btn-sm border-0 p-2 text-white"
                style={{ opacity: 0.7 }}
                onClick={() => {
                  this.Logout();
                }}
                title={["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}
              >
                <span className="icon">{"\uf08b"}</span>
              </button>
            </div>
          </div>
        </div>

        {isStaff && (
          <CustomerPickerModal
            show={modal_customer}
            // ยังไม่เคยเลือก = ปิด modal เองไม่ได้ (ไม่ส่ง onHide) ต้องเลือกลูกค้าก่อนถึงจะใช้พอร์ทัลได้
            onHide={selected_customer ? this.closeCustomerPicker : undefined}
            selectedUid={selected_customer?.uid}
          />
        )}
      </div>
    );
  }
}
